import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { FilterConfig } from '../filter-config';

export const FILTER_CONFIG = new InjectionToken<FilterConfig>('FILTER_CONFIG');
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private readonly apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(FILTER_CONFIG) private readonly config: FilterConfig
  ) {
    this.apiUrl = config.apiUrl;
  }

  getAllDepartments() {
    return this.http.get(`${this.apiUrl}/api/departments/all`);
  }
}
